// frontend/src/lib/api.js
export const API_BASE = (process.env.REACT_APP_API_BASE_URL || "http://localhost:4000").replace(/\/+$/, "");

function pickMessage(status, bodyText, statusText) {
  // prefer JSON error message
  try {
    const j = JSON.parse(bodyText);
    if (j?.error) return j.error;
    if (j?.message) return j.message;
  } catch {}
  // fallbacks
  const text = (bodyText || "").trim();
  if (text && !/^<!DOCTYPE html>/i.test(text)) return text; // avoid dumping HTML
  if (status >= 500) return "Server error";
  if (status === 404) return "Not found";
  if (status === 409) return "Conflict";
  if (status === 400) return "Bad request";
  if (status === 401) return "Unauthorized";
  if (status === 403) return "Forbidden";
  return statusText || "Request failed";
}

async function request(path, options = {}) {
  const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
  const headers = {
    ...(options.headers || {}),
  };
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const token = localStorage.getItem("token");
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  const bodyText = await res.text();

  if (!res.ok) {
    // Special case: if requesting /auth/me and we get 401, treat as not logged in
    if (res.status === 401 && path.startsWith('/auth/me')) {
      return null;
    }
    const msg = pickMessage(res.status, bodyText, res.statusText);
    const err = new Error(msg);
    err.status = res.status;
    err.body = bodyText;
    throw err;
  }

  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? JSON.parse(bodyText) : bodyText;
}

const get   = (path)      => request(path);
const del   = (path)      => request(path, { method: "DELETE" });
const post  = (path, body) => request(path, { method: "POST", body: JSON.stringify(body) });
const put   = (path, body) => request(path, { method: "PUT",  body: JSON.stringify(body) });
const patch = (path, body) => request(path, { method: "PATCH", body: JSON.stringify(body) });

export const api = {
  request,
  get,
  post,
  put,
  patch,
  del,

  // 🔹 Upload helper — sends FormData correctly
  upload: async (path, formData) => {
    const url = `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

    const res = await fetch(url, {
      method: "POST",
      body: formData,
      // ⚠️ No Content-Type here; browser sets multipart/form-data
      headers: {
        Authorization: localStorage.getItem("token")
          ? `Bearer ${localStorage.getItem("token")}`
          : undefined
      },
    });

    const bodyText = await res.text();

    // Try to parse JSON, otherwise error
    let json;
    try {
      json = JSON.parse(bodyText);
    } catch {
      console.error("Upload response was not JSON:", bodyText);
      throw new Error(
        "Upload failed: server returned HTML instead of JSON. " +
          "This means the upload request went to the frontend instead of the backend."
      );
    }

    if (!res.ok) {
      throw new Error(json.error || `Upload failed (${res.status})`);
    }

    return json;
  }
};

